import { useMemo } from "react";
import { ScheduleHistory, ScheduleHistoryRow } from "../types";

export const useHistoryWithKeys = (history: ScheduleHistory[]): ScheduleHistoryRow[] => {
  return useMemo(
    () =>
      history.map((item) => ({
        ...item,
        key: `sched-${item.scheduleId}`,
      })),
    [history]
  );
};

export const useGroupedHistory = (historyWithKeys: ScheduleHistoryRow[]): ScheduleHistoryRow[] => {
  return useMemo(() => {
    const groups = new Map<string, ScheduleHistoryRow[]>();

    historyWithKeys.forEach((item) => {
      const employeeId = item.employee.employeeID?.toString() || "unknown";
      const group = groups.get(employeeId) ?? [];
      group.push(item);
      groups.set(employeeId, group);
    });

    return Array.from(groups.values()).map((items) => {
      const employee = items[0]?.employee;
      return {
        key: `emp-${employee?.employeeID ?? "unknown"}`,
        isGroup: true,
        employee: employee,
        scheduleId: `emp-${employee?.employeeID ?? "unknown"}`,
        title: "",
        note: "",
        scheduleDate: "",
        startTime: "",
        endTime: "",
        requireSync: false,
        syncStatus: "",
        employeeActivity: undefined,
        subRows: items,
      } as ScheduleHistoryRow;
    });
  }, [historyWithKeys]);
};
